export default __webpack_public_path__ + "static/media/stone_hover.f5a36340.mp3";